import { render, staticRenderFns } from "./staffpayroll.vue?vue&type=template&id=18887660&"
import script from "./staffpayroll.vue?vue&type=script&lang=js&"
export * from "./staffpayroll.vue?vue&type=script&lang=js&"
import style0 from "./staffpayroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports